// extracted by css-extract-rspack-plugin
export default {"container":"Description-module__container__hpqJz","compact":"Description-module__compact__MrdGt"};